module.exports = __webpack_public_path__ + "img/es.426a1551.svg";